/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "./MentorLandingLeadPage.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faCalendarAlt,
  faQuoteLeft,
  faUserTie,
  faFileVideo,
  faPeopleGroup,
  faUsersViewfinder,
  faHandHoldingDollar,
} from "@fortawesome/free-solid-svg-icons";

export default ({ props }) => {
  const scrollHandler = (id) => {
    var element = document.getElementById(id);
    window.scrollTo(0, element.offsetTop - 80);
  };
  return (
    <div className="landing-lead-page mentor-landing text-dark-5 bg-white">
      <header className="landing-page-header py-4 py-md-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-3 col-4">
              <a href="/" className="logo">
                <img src="./assets/images/logo-2.png" alt="logo" />
              </a>
            </div>
            <div className="col-md-9 col-8">
              <ul className="d-flex justify-content-end mb-0 align-items-center">
                <li className="ml-2 ml-md-4">
                  <a href="/employers" className="font-weight-bold">
                    For Employers
                  </a>
                </li>
                <li className="ml-2 ml-md-4">
                  <a
                    href="/sign-up"
                    className="btn btn-green btn-big text-uppercase font-weight-bold"
                  >
                    Sign Up
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>

      <div className="landing-lead-page-banner text-center">
        {/* <h2 className="font-weight-normal mb-3">Discover the power of</h2> */}
        <h1 className="text-dark-8">Start earning a second income today</h1>
        <h2 className="mb-5 font-weight-normal">
          Leverage your <span className="text-green"> Network </span> and{" "}
          <span className="text-green"> Expertise </span>.
        </h2>

        <a
          href="/mentor-sign-up"
          className="btn btn-big btn-green text-uppercase font-weight-bold"
        >
          Join Now
        </a>

        <p className="mt-5 mb-4">See How</p>
        <button
          className="border-0 bg-transparent"
          onClick={() => scrollHandler("DemoSection")}
        >
          <FontAwesomeIcon icon={faAngleDown} />
        </button>
      </div>

      <div
        className="landing-lead-page-features text-center bg-light-5 py-5 "
        id="DemoSection"
      >
        <div className="container py-md-5">
          <h2 className="mb-4 font-weight-normal text-dark-8">
            You are an expert
          </h2>
          <h3 className="mb-5 font-weight-normal  text-dark-8">
            You have the experience. You have seen the problems. Now is the
            chance to help solve them and get paid to do so.
          </h3>
          <div className="row">
            <div className="col-md-3">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faPeopleGroup} />
                </div>
                <h4 className="mb-4 text-dark-6">Source</h4>
                <p className="font-weight-bold text-dark-5">
                  Use your network to find great profiles.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="feature-box-2">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faUsersViewfinder} />
                </div>
                <h4 className="mb-4 text-dark-6">Assess</h4>
                <p className="font-weight-bold text-dark-5">
                  Use our assessment kits and ai to quickly screen and filter
                  the best profiles
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="feature-box-2">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faFileVideo} />
                </div>
                <h4 className="mb-4 text-dark-6">Interview</h4>
                <p className="font-weight-bold text-dark-5">
                  Use your valuable knowledge and years of expertise to
                  interview and evaluate.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="feature-box-2">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faHandHoldingDollar} />
                </div>
                <h4 className="mb-4 text-dark-6">Submit</h4>
                <p className="font-weight-bold text-dark-5">
                  Submit the best profiles to relevant positions and earn
                  serious $$ when they get hired
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-reviews text-center  my-5 ">
        <div className="container py-md-5">
          <h2 className="mb-5 font-weight-normal text-dark-8">
            Rave Reviews{" "}
            <span className="text-light-5">From Our Early Mentors. </span>
          </h2>
          <div className="icon text-green-2 mb-5">
            <FontAwesomeIcon icon={faQuoteLeft} />
          </div>
          <div className="">
            <p className="mb-5 text-left">
              Thanks to Jigsaw, I've not only optimized my interviewing process
              but also found a lucrative avenue for earning through interviews
              conducted on the platform. Its efficiency has allowed me to take
              on more interviews, resulting in increased revenue. Highly
              recommended for both efficiency and profitability.
            </p>
            <h4 className="text-green font-weight-normal">— Max</h4>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-highlight my-5">
        <div className="container py-md-5">
          <div className="col-md-10 px-0 mx-auto">
            <h2 className="mb-4 text-black font-weight-bold">
              Smarter Not Harder
            </h2>
            {/* <p className="mb-5 pt-3">
              Mentors play a crucial role in identifying, nurturing, and
              evaluating potential candidates, contributing significantly to the
              overall success of the hiring process.
            </p> */}
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">01</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Be the bridge that has been missing.
                    </h3>
                    <p>Recruiting has been broken for years. Help us fix it</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">02</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">Tools</h3>
                    <p>
                      Use our tools to automate all mundane repetitive tasks
                      like scheduling, messaging, assessments and matching
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">03</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      LinkedIn Premium Included
                    </h3>
                    <p>
                      LinkedIn Premium included at no charge when you signup
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">04</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Boutique Recruiting
                    </h3>
                    <p>
                      Be a one stop boutique recruiting company. We provide the
                      rest.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">05</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Lots more coming
                    </h3>
                    <p>
                      We are actively working with partners to make this a
                      complete ecosystem. Automated background checks, lots of
                      AI Automations, Sourcing partners to name a few
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="landing-lead-page-footer py-4">
        <div className="container text-white text-center py-2 font-weight-bold">
          <p className="mb-0">
            © Copyright 2023 • Jigsaw •{" "}
            <a href="/privacy-policy" className="text-white">
              Privacy Policy
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};
